<template>
  <router-view />
</template>

<script>
import storeMixin, {
  unRegisterMixin,
} from '@quisit/mipe-utils/mixins/storeGenerator';

export default {
  name: 'CompuMinutesEditorWrapper',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: 'compuMinutesEditor',
  }),
};
</script>
